export default "__VITE_ASSET__FO5ltLIJ__"